import { client } from "@/hono";
import { useAuth } from "@/hooks/use-auth";
import { PartnerTimelineAssignmentReferenceItem } from "@/sites/partners/partner/partner-timeline/partner-timeline-assignment-reference-item";
import { ColoredIcon, icon } from "@msuite/ui/icons";
import { useQuery } from "@msuite/ui/query";
import { Timeline, TimelineWeeklyControls, useTimelineWeeklyControls } from "@msuite/ui/timeline";
import { responseHandler } from "@msuite/ui/utils";
import { guardString } from "@msuite/utils/strings";

export function ExternalServicesTimeline() {
	/** Hooks */
	const { organization } = useAuth();
	const { currentWeek } = useTimelineWeeklyControls();

	/** Query */
	const {
		data: timeline,
		isLoading,
		refetch,
		queryKey,
	} = useQuery({
		queryKey: ["external-services-timeline", currentWeek],
		queryFn: async () => {
			const response = await client.organizations[":orgId"].partnerships[
				"external-services"
			].timeline.$get({
				param: {
					orgId: guardString(organization?.id),
				},
				query: {
					week: currentWeek,
				},
			});
			const data = await responseHandler(response);
			return data.timeline;
		},
	});

	/** Render */
	return (
		<Timeline
			controls={<TimelineWeeklyControls queryKey={queryKey} />}
			showEmptySections
			timeline={timeline}
			renderItemMarker={() => (
				<ColoredIcon
					icon={icon("Calendar")}
					color="emerald"
				/>
			)}
			renderItem={(_, item) => (
				<PartnerTimelineAssignmentReferenceItem
					item={item}
					partnershipId={item.partnershipId}
				/>
			)}
			isLoading={isLoading}
			refetch={refetch}
		/>
	);
}
